// Copyright (c) 2020 Deere & Company

import actions from '../../action-list';

export const updateTemporaryObjectKey = temporaryObjectKey =>

    dispatch => {

        dispatch({
            temporaryObjectKey,
            type: actions.UPDATE_CLAIM_WEAR_PARTS_TEMPORARY_OBJECT_KEY
        });

    };



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-creators/update-temporary-object-key.js